$("#owl-carousel").owlCarousel({
            loop: true,
            items: 4,
            margin: 40,
            dots: false,
            nav: false,
            // autoplay: true,
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-long-arrow-left review_left_arrow"></i>', '<i class="fa fa-long-arrow-right review_right_arrow"></i>'],
            responsive: {
                0: {
                    items: 3,
                    margin: 10,
                },
                575: {
                    items: 3,
                    margin: 20,
                },
                767: {
                    items: 3,
                },
                1170: {
                    items: 4,
                },
            },
        });

        $("#cstm-owl-carousel").owlCarousel({
            loop: true,
            items: 3,
            margin: 40,
            dots: false,
            nav: true,
            center: true,
            navText: ['<i class="fa fa-long-arrow-left cstm_left_arrow"></i>', '<i class="fa fa-long-arrow-right cstm_right_arrow"></i>'],
            responsive: {
                0: {
                    items: 1,
                    margin: 30,
                },
                575: {
                    items: 2,
                    margin: 20,
                    stagePadding: 50,
                },
                767: {
                    items: 2,
                    margin: 20,
                },
                1170: {
                    items: 3,
                },
            },
        });